/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-connect': {
    width: 16,
    height: 16,
    viewBox: '0 0 45 45',
    data: '<g _fill="#1988ef"><path pid="0" d="M41 12.5h-3.9v15.1c0 1.3-1.7 3-3 3H18.9c0 1.7 1.4 2.8 3.1 2.8h6l7.8 7.1v-7.1H41c1.7 0 3.1-1 3.1-2.8V15.5c0-1.7-1.4-3-3.1-3z"/><path pid="1" d="M31.2 4.4H4C2.3 4.4.9 5.8.9 7.5v17.3C.9 26.6 2.3 28 4 28h5.2v7.1l7.9-7.1h14.1c1.7 0 3.1-1.4 3.1-3.1V7.5c0-1.7-1.4-3.1-3.1-3.1zM10.4 18.6c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3c1.3 0 2.3 1 2.3 2.3s-1 2.3-2.3 2.3zm6.8 0c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1.1 2.3-2.3 2.3zm6.7 0c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3c1.3 0 2.3 1 2.3 2.3s-1 2.3-2.3 2.3z"/></g>'
  }
})
